import React from 'react'
import styled from 'styled-components'
import { radius, font } from 'features/dashboard/tokens'

const StatCard = ({ value, label, sub, tint = '#0C1229', onClick }) => (
  <Wrap $clickable={!!onClick} onClick={onClick || undefined} title={onClick ? label : undefined}>
    <Value $tint={tint}>{value}</Value>
    <Label>{label}</Label>
    {sub ? <Sub>{sub}</Sub> : null}
  </Wrap>
)

export default StatCard

const Wrap = styled.div`
  display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 4px;
  padding: 20px 12px;
  text-align: center;
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
`

const Value = styled.span`
  font-family: 'FuturaPT-Light', system-ui, sans-serif;
  font-size: 46px;
  letter-spacing: -1.5px;
  color: ${({ $tint }) => $tint};
  line-height: 1;
`

const Label = styled.span`
  font-size: ${font.emphasis};
  font-weight: 800;
  color: ${({ theme }) => theme.colors.haiti};
`

const Sub = styled.span`
  font-size: ${font.caption};
  color: ${({ theme }) => theme.colors.grey[800]};
  line-height: 1.4;
  max-width: 220px;
`
